import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { ModalComponent } from "src/app/shared/modals/modal.component";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {

  @ViewChild('modal') modal!: ModalComponent;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router
  ) {}

  ngOnInit() {}

  collapseShow = "hidden";

  collapse = false;
  submenuOpen: string | null = null; // Tracks the currently open submenu's key


  toggleSubmenu(menuKey: string) {
    this.submenuOpen = this.submenuOpen === menuKey ? null : menuKey;
  }
  
  toggleCollapseShow(classes) {
    this.collapseShow = classes;
  }

  logout() {
    this.oidcSecurityService.logoff().subscribe((res: any) => {
      console.log(res);

      this.router.navigate(['/']);
      
    })
  }


  // openModal() {
  //   this.modal.open();
  // }

  // closeModal() {
  //   this.modal.close();
  // }

}
